<script setup lang="ts" generic="K extends object">
import ColoredHeadline from 'pejer/src/components/ColoredHeadline.vue'
import HeadlinedItem from 'pejer/src/components/HeadlinedItem.vue'

import { FlexRender } from '@tanstack/vue-table'
import { computed } from 'vue'
import { cn } from '../lib/utils'
import { GroupsWithColumns } from '../tables'
import { getNestedObject } from '../tables/helpers'
import SectionCard from './ui/section-card/SectionCard.vue'

const props = defineProps<{
  group: GroupsWithColumns<any>[string]
  item: K
  class?: string
}>()

const cellProps = computed(() => ({
  row: { original: props.item },
}))

const shouldShowValue = (value: any) => {
  if (value === undefined || value === null) {
    return false
  }
  if (typeof value === 'string' && value.trim() === '') {
    return false
  }
  if (Array.isArray(value) && value.length === 0) {
    return false
  }
  return true
}
</script>
<template>
  <SectionCard :class="cn('relative', props.class)">
    <ColoredHeadline
      :text="group.name"
      :color="group.color.accent"
      class="sticky top-0 bg-white/90 z-50"
    >
      <template v-slot:icon>
        <component :is="group.icon" class="w-6 h-6 mr-2 text-secondaryBlack" />
      </template>
    </ColoredHeadline>

    <div class="grid grid-cols-2 gap-2 w-full mt-6">
      <template v-for="column of group.columns" :key="column.id">
        <HeadlinedItem
          v-if="!column.meta.hideFromTable"
          :header="(column.header as string) || 'No header'"
        >
          <div
            v-if="
              column.accessorKey &&
              (shouldShowValue(getNestedObject(item, column.accessorKey as string)) ||
                column.meta.forceDisplay)
            "
            class="w-full text-wrap break-words"
          >
            <FlexRender :render="column.cell" :props="cellProps" />
          </div>
        </HeadlinedItem>
      </template>
      <slot />
    </div>
  </SectionCard>
</template>
